import { h, Component } from "preact";

import classname from "../../../foundation/utils/classname";
import { calculateCropHeight, SnapshotThumbnailSourceData } from "../../../foundation/utils/image";
import ResizedImage from "../../ResizedImage";

import styles from "./ThumbnailImage.module.css";

interface Props {
    width: number;
    height: number;
    index?: number;
    snapshotWidth?: number;
    snapshotHeight?: number;
    source?: string; // This is old version of crop image url source
    thumbnailImageSource?: SnapshotThumbnailSourceData;
}

interface State {
    source?: string;
    loading: boolean;
}

const EAGER_INDEX_THRESHOLD = 6;

class ThumbnailImage extends Component<Props, State> {
    override state: State = {
        source: undefined,
        loading: false
    };

    handleImageLoad = () => {
        this.setState({
            loading: false
        });
    };

    override componentDidMount() {
        const { source, thumbnailImageSource } = this.props;

        this.setState({
            source,
            loading: thumbnailImageSource ? !!thumbnailImageSource : !!source
        });
    }

    override componentDidUpdate() {
        const { source: nextSource, thumbnailImageSource } = this.props;
        const { source: currentSource } = this.state;

        if (thumbnailImageSource && thumbnailImageSource.status !== "error") {
            return;
        }

        if (nextSource !== currentSource) {
            this.setState({
                source: nextSource,
                loading: true
            });
        }
    }

    render() {
        const {
            index,
            width,
            height,
            thumbnailImageSource,
            snapshotWidth,
            snapshotHeight
        } = this.props;
        const imgLoadingAttr = typeof index === "number" && index < EAGER_INDEX_THRESHOLD
            ? "eager"
            : "lazy";

        const { loading, source } = this.state;
        const shouldDisplayOptimizedThumbnail =
            thumbnailImageSource?.status &&
            thumbnailImageSource?.status !== "error" &&
            window.devicePixelRatio <= 1
                ? thumbnailImageSource?.src
                : thumbnailImageSource?.srcset;

        if (shouldDisplayOptimizedThumbnail) {
            const thumbnailLoading = loading || thumbnailImageSource!.status === "processing";
            const imgDynamicHeight = calculateCropHeight({
                width: snapshotWidth!,
                height: snapshotHeight!
            });

            return (
                <div
                    class={classname(styles.thumbnailImageFrame, { breathe: thumbnailLoading })}
                    style={{ width, height: imgDynamicHeight }}>
                    {
                        thumbnailImageSource!.status === "ready" && (
                            <img
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                decoding="async"
                                loading={imgLoadingAttr}
                                alt=""
                                id={thumbnailImageSource!.screenId}
                                class={styles.thumbnailImage}
                                src={thumbnailImageSource!.src}
                                srcSet={thumbnailImageSource!.srcset}
                                width={width}
                                height={height}
                                onLoad={this.handleImageLoad}/>
                        )
                    }
                </div>
            );
        }

        return (
            <div class={classname(styles.thumbnailImageFrame, { breathe: loading })} style={{ width, height }}>
                {source && (
                    <ResizedImage
                        class={styles.thumbnailImage}
                        source={source}
                        width={width}
                        height={height}
                        onLoad={this.handleImageLoad}/>
                )}
            </div>
        );
    }
}

export default ThumbnailImage;
export { Props as ThumbnailImageProps };
